module.exports = __webpack_public_path__ + "static/media/location verde 2.d9ba35c5.svg";